import React, { forwardRef } from 'react';

import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import { END_OF_DAY, START_OF_DAY } from '@vlabs/shared/config';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './DateFilterPopover.module.sass';
import { useListListPageFilters } from '../../useListListPageFilters';

function UpdateDateFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const { filters, updateFilters } = useListListPageFilters();

  return (
    <PopoverWithButton
      {...props}
      onClickReset={() => updateFilters({
        last_update_time__gte: undefined,
        last_update_time__lt: undefined,
      })}
      ref={ref}
    >
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          enableTime
          id="last_update_time__gte"
          label={t('from_label') ?? ''}
          name="last_update_time__gte"
          onChange={([last_update_time__gte]: Date[]) => updateFilters({ last_update_time__gte })}
          options={START_OF_DAY}
          value={filters.last_update_time__gte ?? ''}
        />
      </div>
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          enableTime
          id="last_update_time__lt"
          label={t('to_label') ?? ''}
          name="last_update_time__lt"
          onChange={([last_update_time__lt]: Date[]) => updateFilters({ last_update_time__lt })}
          options={END_OF_DAY}
          value={filters.last_update_time__lt ?? ''}
        />
      </div>
    </PopoverWithButton>
  );
}

const UpdateDateFilterPopoverWithRef = forwardRef(UpdateDateFilterPopover);
export { UpdateDateFilterPopoverWithRef as UpdateDateFilterPopover };
